var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "comprehensive-table-container" },
    [
      _c(
        "vab-query-form",
        [
          _c(
            "vab-query-form-top-panel",
            [
              _c(
                "el-form",
                {
                  ref: "queryForm",
                  attrs: {
                    inline: true,
                    "label-width": "140px",
                    model: _vm.queryForm
                  },
                  nativeOn: {
                    submit: function($event) {
                      $event.preventDefault()
                    }
                  }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "中国海关编码", prop: "hsCode" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "180px" },
                        attrs: { clearable: "", placeholder: "请输入" },
                        model: {
                          value: _vm.queryForm.hsCode,
                          callback: function($$v) {
                            _vm.$set(_vm.queryForm, "hsCode", $$v)
                          },
                          expression: "queryForm.hsCode"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "商品名称", prop: "items" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "180px" },
                        attrs: { clearable: "", placeholder: "请输入" },
                        model: {
                          value: _vm.queryForm.items,
                          callback: function($$v) {
                            _vm.$set(_vm.queryForm, "items", $$v)
                          },
                          expression: "queryForm.items"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            icon: "el-icon-search",
                            "native-type": "submit",
                            type: "primary"
                          },
                          on: { click: _vm.handleQuery }
                        },
                        [_vm._v(" 查询 ")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { "native-type": "submit" },
                          on: {
                            click: function($event) {
                              return _vm.reset("queryForm")
                            }
                          }
                        },
                        [_vm._v(" 重置 ")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "vab-query-form-left-panel",
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.addOrEdit }
                },
                [_vm._v(" 新增 ")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    disabled: !_vm.queryForm.idList.length > 0,
                    size: "mini",
                    type: "danger"
                  },
                  on: { click: _vm.deleteData }
                },
                [_vm._v(" 删除 ")]
              ),
              _c("uploadExcel", {
                attrs: {
                  "down-url": "海关编码字典导入模板.xlsx",
                  "upload-aciton": _vm.bt
                }
              }),
              _c(
                "el-button",
                {
                  attrs: {
                    loading: _vm.loadingExPort,
                    size: "mini",
                    type: "primary"
                  },
                  on: { click: _vm.exPort }
                },
                [_vm._v(" 导出 ")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.showRegulatoryConditionsCodeTableAction }
                },
                [_vm._v(" 监管条件代码表 ")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.showCodeTableAction }
                },
                [_vm._v(" 检验检疫代码表 ")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.openColumnSettings }
                },
                [_vm._v(" 设置列 ")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { height: "calc(100vh - 320px)" } },
        [
          _c(
            "vxe-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading"
                }
              ],
              ref: "tableRef",
              attrs: {
                id: "customsCodeManageTable",
                border: "",
                "checkbox-config": { trigger: "row", range: true },
                "custom-config": _vm.customConfig,
                data: _vm.list,
                height: "100%",
                "keep-source": true,
                "row-config": { isHover: true, isCurrent: true, height: 35 },
                "scroll-y": { enabled: true },
                "show-overflow": ""
              },
              on: {
                "checkbox-all": _vm.setSelectRows,
                "checkbox-change": _vm.setSelectRows
              },
              scopedSlots: _vm._u([
                {
                  key: "empty",
                  fn: function() {
                    return [
                      _c("el-image", {
                        staticClass: "vab-data-empty",
                        attrs: {
                          src: require("@/assets/empty_images/data_empty.png")
                        }
                      })
                    ]
                  },
                  proxy: true
                }
              ])
            },
            [
              _c("vxe-column", {
                attrs: {
                  align: "center",
                  field: "selectOption",
                  fixed: "left",
                  type: "checkbox",
                  width: "55"
                }
              }),
              _c("vxe-column", {
                attrs: {
                  align: "center",
                  field: "indexOption",
                  fixed: "left",
                  title: "序号",
                  type: "seq",
                  width: "70"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var seq = ref.seq
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              seq +
                                (_vm.queryForm.pageNum - 1) *
                                  _vm.queryForm.pageSize
                            ) +
                            " "
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("vxe-column", {
                attrs: {
                  align: "center",
                  field: "hsCode",
                  "min-width": "120",
                  title: "中国海关编码"
                }
              }),
              _c("vxe-column", {
                attrs: {
                  align: "center",
                  field: "category",
                  "min-width": "140",
                  title: "大类"
                }
              }),
              _c("vxe-column", {
                attrs: {
                  align: "center",
                  field: "chapter",
                  "min-width": "140",
                  title: "章节"
                }
              }),
              _c("vxe-column", {
                attrs: {
                  align: "center",
                  field: "items",
                  "min-width": "200",
                  title: "商品名称"
                }
              }),
              _c("vxe-column", {
                attrs: {
                  align: "center",
                  field: "description",
                  "min-width": "200",
                  title: "商品描述"
                }
              }),
              _c("vxe-column", {
                attrs: {
                  align: "center",
                  field: "declarationElementsCn",
                  "min-width": "200",
                  title: "中国申报要素"
                }
              }),
              _c("vxe-column", {
                attrs: {
                  align: "center",
                  field: "regulatoryCondition",
                  "min-width": "100",
                  title: "监管条件"
                }
              }),
              _c("vxe-column", {
                attrs: {
                  align: "center",
                  field: "generalRates",
                  "min-width": "100",
                  title: "普通税率"
                }
              }),
              _c("vxe-column", {
                attrs: {
                  align: "center",
                  field: "preferentialRates",
                  "min-width": "100",
                  title: "优惠税率"
                }
              }),
              _c("vxe-column", {
                attrs: {
                  align: "center",
                  field: "exitRates",
                  "min-width": "200",
                  title: "出口税率"
                }
              }),
              _c("vxe-column", {
                attrs: {
                  align: "center",
                  field: "consumeRates",
                  "min-width": "200",
                  title: "消费税率"
                }
              }),
              _c("vxe-column", {
                attrs: {
                  align: "center",
                  field: "vatRates",
                  "min-width": "200",
                  title: "增值税率"
                }
              }),
              _c("vxe-column", {
                attrs: {
                  align: "center",
                  field: "firstLegalUnit",
                  "min-width": "200",
                  title: "第一法定单位"
                }
              }),
              _c("vxe-column", {
                attrs: {
                  align: "center",
                  field: "secondLegalUnit",
                  "min-width": "200",
                  title: "第二法定单位"
                }
              }),
              _c("vxe-column", {
                attrs: {
                  align: "center",
                  field: "inspection",
                  "min-width": "200",
                  title: "检验检疫"
                }
              }),
              _c("vxe-column", {
                attrs: {
                  align: "center",
                  field: "createBy",
                  "min-width": "200",
                  title: "创建人"
                }
              }),
              _c("vxe-column", {
                attrs: {
                  align: "center",
                  field: "createTime",
                  "min-width": "200",
                  title: "创建时间"
                }
              }),
              _c("vxe-column", {
                attrs: {
                  align: "center",
                  field: "updateBy",
                  "min-width": "200",
                  title: "修改人"
                }
              }),
              _c("vxe-column", {
                attrs: {
                  align: "center",
                  field: "updateTime",
                  "min-width": "200",
                  title: "修改时间"
                }
              }),
              _c("vxe-column", {
                attrs: {
                  align: "center",
                  field: "dataSource",
                  "min-width": "200",
                  title: "数据来源"
                }
              }),
              _c("vxe-column", {
                attrs: {
                  align: "center",
                  field: "option",
                  fixed: "right",
                  title: "操作",
                  width: "60"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        _c(
                          "el-button",
                          {
                            staticStyle: { padding: "0" },
                            attrs: { type: "text" },
                            on: {
                              click: function($event) {
                                return _vm.addOrEdit(row)
                              }
                            }
                          },
                          [_vm._v(" 编辑 ")]
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _c("el-pagination", {
        attrs: {
          background: "",
          "current-page": _vm.queryForm.pageNum,
          layout: _vm.layout,
          "page-size": _vm.queryForm.pageSize,
          total: _vm.total
        },
        on: {
          "current-change": _vm.handleCurrentChange,
          "size-change": _vm.handleSizeChange
        }
      }),
      _c("table-edit", {
        ref: "edit",
        attrs: {
          modulelist: _vm.queryList,
          "system-guid": _vm.queryForm.systemGuid
        }
      }),
      _c("regulatory-conditions-code-table", {
        attrs: { open: _vm.showRegulatoryConditionsCodeTable },
        on: {
          "update:open": function($event) {
            _vm.showRegulatoryConditionsCodeTable = $event
          }
        }
      }),
      _c("code-table-for-inspection-and-quarantine", {
        attrs: { open: _vm.showCodeTable },
        on: {
          "update:open": function($event) {
            _vm.showCodeTable = $event
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }